<div>
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
  <ngx-editor
    [formControl]="control"
    [editor]="editor"
    [ngModel]="html"
    (ngModelChange)="onContentChange($event)"
    [disabled]="false"
    [placeholder]="
      placeHolder ? placeHolder : ('messages.enterYourText' | translate)
    "
  ></ngx-editor>
</div>

<i
  (click)="toggleFullScreen()"
  [class]="isFullScreen ? ' mdi-arrow-up ' : 'mdi-arrow-down'"
  class="cursor-pointer tw-p-1 rounded tw-bg-white dark:!tw-bg-dark-500 mdi mdi-22px tw-absolute tw-bottom-[-12px] tw-right-3"
></i>
